import {
  createSpinner,
  scrollToEvent,
  validateCheckbox,
  validateEmail,
  validateTextarea,
  validateTextInput,
  validateSelectField,
  validateFileInput,
  updateCharCounter,
} from "../../helpers.js";
import { project } from "../../initializeStats.js";
import { btnAnimation } from "../../btnAnimation.js";

document.querySelectorAll(".btn-upload-trigger").forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    const form = btn.closest("form") || document;
    const photo1 = form.querySelector('input[type="file"][name="photo1"]');
    const photo2 = form.querySelector('input[type="file"][name="photo2"]');
    const photo3 = form.querySelector('input[type="file"][name="photo3"]');

    if (photo1 && !photo1.value) {
      photo1.click();
    } else if (photo2 && !photo2.value) {
      photo2.click();
    } else if (photo3 && !photo3.value) {
      photo3.click();
    }
  });
});

export const validateAndSubmitCastingForm = () => {
  document.querySelectorAll("textarea").forEach((ta) => {
    function adjustHeight() {
      ta.style.height = "54px";
      ta.style.height = `${ta.scrollHeight}px`;
    }
    ta.addEventListener("input", adjustHeight);

    // Initialize character counter
    if (ta.hasAttribute('data-char-limit')) {
      updateCharCounter(ta);
    }
  });

  const forms = document.querySelectorAll(".casting-form");

  if (forms.length) {
    forms.forEach((form) => {
      const textInputs = form.querySelectorAll(
        '.form-field[name="fullname"], .form-field[name="birth_year"]'
      );
      const textareas = form.querySelectorAll(
        '.form-field[name="experience_camera"]'
      );
      const textareasWithLimit = form.querySelectorAll(
        'textarea[data-char-limit]'
      );
      const selectFields = form.querySelectorAll(
        '.form-field[name="gender"], .form-field[name="agency"]'
      );
      const fileInputs = form.querySelectorAll(
        'input[type="file"][name^="photo"]'
      );
      const phoneNumbers = form.querySelectorAll('.form-field[name="phone"]');

      const mails = form.querySelectorAll('.form-field[name="email"]');
      const checkboxesRequired = form.querySelectorAll(
        ".form-checkbox--required input"
      );
      const checkboxesNotRequired = form.querySelectorAll(
        ".form-checkbox:not(.form-checkbox--required) input"
      );

      textInputs.forEach((el) => {
        el.addEventListener("input", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateTextInput(this, 1);
          }
        });
        el.addEventListener("change", function () {
          validateTextInput(this, 1);
        });
      });

      selectFields.forEach((el) => {
        el.addEventListener("change", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateSelectField(this);
          }
        });
      });

      textareas.forEach((el) => {
        el.addEventListener("input", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateTextarea(this, 2);
          }
        });
        el.addEventListener("change", function () {
          validateTextarea(this, 2);
        });
      });

      // Add character counter functionality for textareas with limit
      textareasWithLimit.forEach((el) => {
        el.addEventListener("input", function () {
          updateCharCounter(this);
          const charLimit = parseInt(this.getAttribute('data-char-limit'));
          if (this.value.length > charLimit) {
            this.value = this.value.substring(0, charLimit);
            updateCharCounter(this);
          }
          // Clear error state when user is typing and field has error
          if (el.closest("fieldset").classList.contains("has-error")) {
            const minChar = this.hasAttribute('required') ? 1 : 0;
            validateTextarea(this, minChar, charLimit);
          }
        });
        el.addEventListener("change", function () {
          const charLimit = parseInt(this.getAttribute('data-char-limit'));
          const minChar = this.hasAttribute('required') ? 1 : 0;
          validateTextarea(this, minChar, charLimit);
        });
      });

      phoneNumbers.forEach((el) => {
        el.addEventListener("keydown", (event) => {
          const { key } = event;
          const isAllowedInput = key && key.match(/[0-9\+\-]/);
          const isBackspaceOrDelete =
            event.keyCode === 8 || event.keyCode === 46;
          if (!isAllowedInput && !isBackspaceOrDelete) {
            event.preventDefault();
          }
        });
        el.addEventListener("input", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateTextInput(this, 6);
          }
        });
        el.addEventListener("change", function () {
          validateTextInput(this, 6);
        });
      });

      mails.forEach((el) => {
        el.addEventListener("input", function () {
          if (el.closest("fieldset").classList.contains("has-error")) {
            validateEmail(this);
          }
        });
        el.addEventListener("change", function () {
          validateEmail(this);
        });
      });

      checkboxesRequired.forEach((el) => {
        el.addEventListener("change", function () {
          validateCheckbox(this);
        });
      });

      fileInputs.forEach((el) => {
        el.addEventListener("change", async function () {
          if (this.files.length > 0) {
            const file = this.files[0];

            if (!validateFileInput(this, file)) {
              // Store the validation error message before clearing the file
              const fieldset = this.closest("fieldset");
              const errorMessage = fieldset ? fieldset.getAttribute("data-error") : "";

              this.value = "";
              this.removeAttribute("data-base64");
              this.setAttribute("data-invalid", "true");
              this.setAttribute("data-error-message", errorMessage);
              // Hide any preview that might be showing
              const uploadItem = this.closest(".image-upload-item");
              if (uploadItem) {
                const placeholder = uploadItem.querySelector(".image-upload-placeholder");
                const preview = uploadItem.querySelector(".image-preview");
                if (placeholder && preview) {
                  placeholder.style.display = "block";
                  preview.style.display = "none";
                }
              }
              return;
            }

            // Mark as valid
            this.removeAttribute("data-invalid");
            this.removeAttribute("data-error-message");

            try {
              // Convert to base64 and show preview
              const base64Data = await convertImageToBase64(file);
              showImagePreview(this, base64Data);

              // Store base64 data for form submission
              this.setAttribute("data-base64", base64Data);
            } catch (error) {
              alert("Błąd podczas przetwarzania obrazu");
              this.value = "";
              this.removeAttribute("data-base64");
              this.setAttribute("data-invalid", "true");
            }
          }
        });
      });

      const submitBtn = form.querySelector(".btn-main");

      const data = {};

      // oddanie glosu - wysylanie danych z formularza
      submitBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const formData = new FormData();
        let formIsValid = true;

        // walidacja formularza

        textInputs.forEach((el) => {
          if (!validateTextInput(el, 1)) {
            formIsValid = false;
          } else {
            formData.append(el.getAttribute("id"), el.value);
          }
        });

        selectFields.forEach((el) => {
          if (el.id === "gender") {
            if (!validateSelectField(el)) {
              formIsValid = false;
            } else {
              formData.append(el.getAttribute("id"), el.value);
            }
          }

          if (el.id === "agency") {
            if (el.value === "TAK") {
              const agencyNameInput = form.querySelector(
                '.form-field[name="agency_name"]'
              );
              if (!agencyNameInput || !validateTextInput(agencyNameInput, 1)) {
                formIsValid = false;
              } else {
                formData.append(
                  agencyNameInput.getAttribute("id"),
                  agencyNameInput.value
                );
              }
            }
          }
        });

        textareas.forEach((el) => {
          const charLimit = el.hasAttribute('data-char-limit')
            ? parseInt(el.getAttribute('data-char-limit'))
            : null;
          if (!validateTextarea(el, 1, charLimit)) {
            formIsValid = false;
          } else {
            formData.append(el.getAttribute("id"), el.value);
          }
        });

        // Validate textareas with character limits
        textareasWithLimit.forEach((el) => {
          // Skip if already validated in textareas
          if (el.name === 'experience_camera') return;

          const charLimit = parseInt(el.getAttribute('data-char-limit'));
          if (!validateTextarea(el, 0, charLimit)) {
            formIsValid = false;
          }
        });

        phoneNumbers.forEach((el) => {
          if (!validateTextInput(el, 6)) {
            formIsValid = false;
          } else {
            formData.append(el.getAttribute("id"), el.value);
          }
        });

        mails.forEach((el) => {
          if (!validateEmail(el)) {
            formIsValid = false;
          } else {
            formData.append(el.getAttribute("id"), el.value);
          }
        });

        checkboxesRequired.forEach((el) => {
          if (!validateCheckbox(el)) {
            formIsValid = false;
          } else {
            formData.append(
              el.getAttribute("id"),
              el.closest("fieldset").querySelector("label").innerText
            );
          }
        });

        checkboxesNotRequired.forEach((el) => {
          if (el.checked) {
            formData.append(
              el.getAttribute("id"),
              el.closest("fieldset").querySelector("label").innerText
            );
          }
        });

        fileInputs.forEach((el) => {
          // Check if file is marked as invalid
          if (el.hasAttribute("data-invalid")) {
            formIsValid = false;
            // Restore the original error message instead of re-validating
            const errorMessage = el.getAttribute("data-error-message") || "pole obowiązkowe";
            const fieldset = el.closest("fieldset");
            if (fieldset) {
              fieldset.classList.add("has-error");
              fieldset.setAttribute("data-error", errorMessage);
            }
            return;
          }

          if (el.files.length > 0) {
            const file = el.files[0];
            // Validate file before adding to form data
            if (!validateFileInput(el, file)) {
              formIsValid = false;
              const fieldset = el.closest("fieldset");
              const errorMessage = fieldset ? fieldset.getAttribute("data-error") : "";
              el.setAttribute("data-invalid", "true");
              el.setAttribute("data-error-message", errorMessage);
            } else {
              formData.append(el.getAttribute("id"), el.files[0]);
            }
          }
        });

        const weight = document.getElementById("weight");
        if (weight && weight.value) {
          formData.append(weight.getAttribute("id"), parseFloat(weight.value));
        } else if (weight) {
          formData.append(weight.getAttribute("id"), null);
        }

        const height = document.getElementById("height");
        if (height && height.value) {
          formData.append(height.getAttribute("id"), parseInt(height.value));
        } else if (height) {
          formData.append(height.getAttribute("id"), null);
        }

        const businessCard = document.getElementById("business_card");
        if (businessCard) {
          formData.append(businessCard.getAttribute("id"), businessCard.value);
        }

        const specials = document.getElementById("specials");
        if (specials) {
          formData.append(specials.getAttribute("id"), specials.value);
        }

        const aboutMe = document.getElementById("about_me");
        if (aboutMe) {
          formData.append(aboutMe.getAttribute("id"), aboutMe.value);
        }

        console.log(formData);

        if (formIsValid) {
          createSpinner(form, true);
          form.reset();

          /* WYSYŁANIE FORMULARZA */
          const url = form.getAttribute("data-url");

          (async () => {
            try {
              let response = await (
                await fetch(url, {
                  method: "POST",
                  body: formData,
                })
              ).text();
              response = JSON.parse(response);

              const vC = form.closest(".form__wrapper");
              document.querySelectorAll(".section__subtitle").forEach((el) => {
                el.style.display = "none";
              });

              const returnBtn = `<div class="response-buttons"><a href="/" class="btn-main">Wróc na stronę Główną</a></div>`;
              if (200 === response.status) {
                const message =
                  "Dziękujemy za zgłoszenie. Skontaktujemy się z wybranymi osobami.";
                vC.innerHTML = `<div class="form__response"><p>${message}</p>${returnBtn}</div>`;
                if (vC.querySelectorAll(".form__response .btn-main")) {
                  btnAnimation(
                    vC.querySelectorAll(".form__response .btn-main")
                  );
                }

                WP.push(() => {
                  window.dataLayer.push({
                    event: "site_interaction",
                    eventCategory: "send_casting_form",
                    eventAction:
                      "ontouchstart" in document.documentElement
                        ? "tap"
                        : "click",
                    eventLabel: window.location.href,
                  });
                });
              } else {
                const message =
                  "Wystąpił błąd podczas wysyłania formularza. Proszę spróbuj ponownie później.";
                vC.innerHTML = `<div class="form__response"><p>${message}</p>${returnBtn}</div>`;
                if (vC.querySelectorAll(".form__response .btn-main")) {
                  btnAnimation(
                    vC.querySelectorAll(".form__response .btn-main")
                  );
                }
              }

              scrollToEvent(
                vC.getBoundingClientRect().top + window.scrollY - 90,
                () => {
                  project.isScrollingController(false);
                }
              );
            } catch (err) {
              console.log("Error:", err);
            }
          })();
        } else {
          // Find the first field with error
          const firstErrorField = form.querySelector("fieldset.has-error");
          const scrollTarget = firstErrorField || form.closest(".form__wrapper");

          scrollToEvent(
            scrollTarget.getBoundingClientRect().top +
              window.scrollY -
              150,
            () => {
              project.isScrollingController(false);
            }
          );
        }
      });
    });
  }
};

const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      resolve(event.target.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};

const showImagePreview = (input, base64Data) => {
  const uploadItem = input.closest(".image-upload-item");
  const placeholder = uploadItem.querySelector(".image-upload-placeholder");
  const preview = uploadItem.querySelector(".image-preview");
  const previewImg = preview.querySelector(".preview-image");
  const removeBtn = preview.querySelector(".remove-image");

  placeholder.style.display = "none";
  preview.style.display = "block";
  previewImg.src = base64Data;

  // Handle remove button
  removeBtn.addEventListener("click", () => {
    input.value = "";
    input.removeAttribute("data-base64");
    input.removeAttribute("data-invalid");
    input.removeAttribute("data-error-message");
    placeholder.style.display = "block";
    preview.style.display = "none";
    previewImg.src = "";
    // Clear any validation errors
    const fieldset = input.closest("fieldset");
    if (fieldset) {
      fieldset.classList.remove("has-error");
      fieldset.setAttribute("data-error", "");
    }
  });
};
